import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgFileZip = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 19,
	height: 19,
	viewBox: "0 0 19 19",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M3.5625 15.2539C3.275 15.2539 3.01562 15.1383 2.78438 14.907C2.55313 14.6758 2.4375 14.4164 2.4375 14.1289V4.37891C2.4375 4.09141 2.55313 3.83203 2.78438 3.60078C3.01562 3.36953 3.275 3.25391 3.5625 3.25391H8.8125L9.9375 4.37891H16.3125C16.6 4.37891 16.8594 4.49453 17.0906 4.72578C17.3219 4.95703 17.4375 5.21641 17.4375 5.50391V14.1289C17.4375 14.4164 17.3219 14.6758 17.0906 14.907C16.8594 15.1383 16.6 15.2539 16.3125 15.2539H3.5625ZM12.9375 14.1289H16.3125V5.50391H12.9375V7.22891H14.6625V8.95391H12.9375V10.6789H14.6625V12.4039H12.9375V14.1289ZM3.5625 14.1289H11.2125V12.4039H12.9375V10.6789H11.2125V8.95391H12.9375V7.22891H11.2125V5.50391H9.46875L8.34375 4.37891H3.5625V14.1289ZM3.5625 5.50391V4.37891V14.1289V5.50391Z",
		fill: "#1D1D1D"
	})
});
export default SvgFileZip;
